import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Typography, useTheme } from "@mui/material";
/**
 * Displays the recipe type.
 *
 * @param clickable - Only used in ItemCard
 * @returns
 */
export const ItemChip = ({ style, label, classes, clickable }) => {
    const theme = useTheme();
    return (_jsx(Chip, { style: Object.assign({ marginRight: theme.spacing(0.5), marginBottom: theme.spacing(0.5) }, style), size: "small", label: _jsx(Typography, Object.assign({ variant: "body3" }, { children: label })), clickable: clickable, classes: Object.assign({}, classes) }));
};
